// Enrutado mínimo con la History API: / (proyectos), /archive, /sites/:id/:section, /settings/:section, /login.
import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();
window.addEventListener('popstate', () => listeners.forEach((l) => l()));

export function navigate(to: string, replace = false): void {
  if (to === location.pathname) return;
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  listeners.forEach((l) => l());
}

export function usePath(): string {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => location.pathname,
  );
}

export type Route =
  | { name: 'login' }
  | { name: 'projects'; filter: 'all' | 'archive' }
  | { name: 'site'; id: string; section: string }
  | { name: 'settings'; section: string };

export function parse(path: string): Route {
  const parts = path.split('/').filter(Boolean);
  if (parts[0] === 'login') return { name: 'login' };
  if (parts[0] === 'archive') return { name: 'projects', filter: 'archive' };
  if (parts[0] === 'sites' && parts[1]) return { name: 'site', id: parts[1], section: parts[2] ?? 'general' };
  if (parts[0] === 'settings') return { name: 'settings', section: parts[1] ?? 'account' };
  return { name: 'projects', filter: 'all' };
}
